"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giorgio-di-nogaro": {
    "da856a42": [{
      "hkey": "c21e6907",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-porto-nogaro": [{
      "hkey": "c21e6907",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d4999717": [{
      "hkey": "dbba5633",
      "slug": "chiarisacco-villanova",
      "name": "Chiarisacco-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "dbba5633",
      "slug": "chiarisacco-villanova",
      "name": "Chiarisacco-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7898b40": [{
      "hkey": "47f76b84",
      "slug": "zellina-galli",
      "name": "Zellina-Galli",
      "primary": true,
      "skipSearch": false
    }],
    "zellina": [{
      "hkey": "47f76b84",
      "slug": "zellina-galli",
      "name": "Zellina-Galli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;